interface CountdownData {
	countdownText: string
	endMessage: string
	init(): void
}

export default {
	name: 'countdown',
	component(props: { day: string; hours: string; labels: { days: string; hours: string; minutes: string; seconds: string } }) {
		let intervalId: number | null = null

		return {
			countdownText: '',

			init() {
				const target = new Date(`${props.day}T${props.hours}:00`)

				const updateCountdown = () => {
					const now = new Date()
					const diff = target.getTime() - now.getTime()

					if (isNaN(target.getTime()) || diff <= 0) {
						this.countdownText = ''
						return
					}

					const totalSeconds = Math.floor(diff / 1000)
					const days = Math.floor(totalSeconds / (3600 * 24))
					const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600)
					const minutes = Math.floor((totalSeconds % 3600) / 60)
					const seconds = totalSeconds % 60

					const pad = (n: number) => String(n).padStart(2, '0')

					const parts: string[] = []
					if (days > 0) parts.push(`${pad(days)}${props.labels.days}`)
					parts.push(`${pad(hours)}${props.labels.hours}`)
					parts.push(`${pad(minutes)}${props.labels.minutes}`)
					if (days <= 0) parts.push(`${pad(seconds)}${props.labels.seconds}`)

					this.countdownText = parts.join(' ')
				}

				updateCountdown()
				intervalId = setInterval(updateCountdown, 1000)
			},

			destroy() {
				if (intervalId) {
					clearInterval(intervalId)
					intervalId = null
				}
			}
		}
	}
}
